export type PaletteMode = 'dark' | 'light';

/**
 * Derive MUI palette mode from Horizon's `site.theme`.
 * Priority: explicit dark brand key or dark background tokens.
 */
export const getPaletteModeFromSiteTheme = (siteTheme?: any): PaletteMode => {
  try {
    if (!siteTheme || typeof siteTheme !== 'object') {
      return 'dark'; // default consistent with dx cookie util fallback
    }

    const enabledKey = String(siteTheme?.enabledTheme || '');
    const enabled = enabledKey.toLowerCase();
    if (enabled === 'dark') return 'dark';

    const colors =
      siteTheme?.colors ||
      siteTheme?.[enabledKey]?.colors ||
      siteTheme?.[enabled]?.colors ||
      {};
    if (!enabled && !siteTheme?.colors) return 'dark';

    if (colors?.quaternary === '#121212') return 'dark';
    const custom = Array.isArray(colors?.custom) ? colors.custom : [];
    const pageBg = custom.find((c: any) => c?.id === 'pageBackground');
    if (pageBg?.value === '#121212') return 'dark';

    return 'light';
  } catch {
    return 'dark';
  }
};
